import React from 'react';
import { connect } from 'react-redux'
import { NAME as WORD_PAIRS_NAME } from '../reducer'
import { bindActionCreators } from 'redux'
import { actions as wordSearchContainerActions } from '../actions'
import WordSearchImg from "../../../assets/wordsearch_preex.svg"; //TO DO
import { CSSTransition } from "react-transition-group";
import Timer from "../../Timer/container/Timer"
import ProgressInfo from "../../../components/ProgressInfo";
import GameOver from "../../../components/GameOver";
import { strings } from "../../../constants/strings";
import Grid from "./Grid"
import CountDown from "../../../components/CountDown";
import { getAlphabetForWordSearch } from "../../../helpers/alphabetProvider"
import { WORDS_4 } from "../../../constants/words/words4";
import { WORDS_5 } from "../../../constants/words/words5";
import { WORDS_6 } from "../../../constants/words/words6";
import { WORDS_7 } from "../../../constants/words/words7";
import { wordsJa } from "../../../constants/words/wordsJa";
import { analyticsActions } from "constants/analytics-actions-id";

import { LETTER_PAIRS } from "../../../constants/letter-pairs";

import StartOverlay from "components/StartOverlay";
const lang = document.documentElement.lang.slice(0, 2);
const INFINITY = 2000000000

function shuffle(array) {
  var currentIndex = array.length, temporaryValue, randomIndex;

  while (0 !== currentIndex) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
}

function cellClick(props) {
  let newMatrix = props.newMatrix
  let word = newMatrix[props.rowIndex][props.columnIndex].word
  for (let j = props.columnIndex; 
      newMatrix[props.rowIndex][j] && 
      newMatrix[props.rowIndex][j].special && 
      j < newMatrix[props.rowIndex].length &&
      newMatrix[props.rowIndex][j].word == word;
         j++) {
    newMatrix[props.rowIndex][j].isUsed = true
    newMatrix[props.rowIndex][j].animation = 'greenAnimation'
  }
  for (let j = props.columnIndex - 1; 
      newMatrix[props.rowIndex][j] && 
      newMatrix[props.rowIndex][j].special && 
      newMatrix[props.rowIndex][j].word == word;
        j--) {
    newMatrix[props.rowIndex][j].isUsed = true
    newMatrix[props.rowIndex][j].animation = 'greenAnimation'
  }
  let newLettersToFind = []
  for(let i = 0; i < props.lettersToFind.length;i++) {
    if(props.lettersToFind[i] !== props.newMatrix[props.rowIndex][props.columnIndex].word) {
      newLettersToFind.push(props.lettersToFind[i])
    }
  }
  return ({
    newMatrix: newMatrix,
    lettersToFind: newLettersToFind
  })
}

function generateMatrix(state) {
  let newList = []
  let alphabet
  let forFindWords = []
  let chosenPool
  if(lang == 'ja') {
    chosenPool = state.gridSearchType.wordCategoryPoolsJa[state.gridSearchType.forSearchIndex][Math.floor(Math.random() * state.gridSearchType.wordCategoryPoolsJa[state.gridSearchType.forSearchIndex].length)] 
    alphabet = getAlphabetForWordSearch(lang, chosenPool.split('_')[0])
  } else {
    alphabet = getAlphabetForWordSearch(lang)
  }
  let newMatrix = []
  for (let i = 0; i < state.GRIG_HEIGHT; i++) {
    let newRow = []
    for (let j = 0; j < state.GRID_WIDTH; j++) {
      let letter
      let randomPositionIndex
      let condition
      do {
        randomPositionIndex = Math.floor(Math.random() * alphabet.length)
        letter = alphabet[randomPositionIndex];
        if(randomPositionIndex === 0) {
          condition = true
        } else {
          condition = alphabet[randomPositionIndex] === alphabet[randomPositionIndex-1]
        }
      } while (condition)
      newRow.push({ value: letter })
    }
    newMatrix.push(newRow)
  }
  for(let i = 0; i< 3; i++) {
    let condition = false
    let word
    let wordString
    if(lang == 'ja') {
      let wordsForSearch = state.gridSearchType.wordsForSearch
      word = wordsForSearch[chosenPool]
      word = word.array[word.index]
      wordString = word
      state.gridSearchType.wordsForSearch[chosenPool].index++
      forFindWords.push(wordString)
      word = word.split('')
    } else {
      word = state.gridSearchType.wordsForSearch[state.gridSearchType.forSearchLengthArray[state.gridSearchType.forSearchIndex+i]]
      word = word.array[word.index]
      state.gridSearchType.wordsForSearch[state.gridSearchType.forSearchLengthArray[state.gridSearchType.forSearchIndex+i]].index++
      wordString = word.toUpperCase()
      forFindWords.push(wordString)
      word = word.toUpperCase().split('')
    }   
    // --------------------------------Paste word for search------
    do {
      condition = false
      let randi = Math.floor(Math.random() * state.GRIG_HEIGHT);            
      let randj = Math.floor(Math.random() * state.GRID_WIDTH);   
      if(randj + word.length > state.GRID_WIDTH) {
        condition = true
      } else {
        //------------------------------------------------Check valid------------To DO fix that words can ganarete around other word
        if((randj != 0 && newMatrix[randi][randj - 1].special) || (newMatrix[randi][randj + word.length-1].special)) {
          condition = true
        } else {
          for(let j=randj,k=0;k<word.length;j++,k++) {
            if(newMatrix[randi][j].special) {
              condition = true
              break
            }
          }
        } 
        //---------------------------------------------------------------------------------             
      }
      if (!condition) {
        newList.push({
          rowIndex: randi,
          columnIndex: randj,
          cellsCount: word.length,
          used: false
        })
        for (let j = randj, k = 0; k < word.length; j++, k++) {
          newMatrix[randi][j] = {
            value: word[k],
            special: true,
            word: wordString
          }
        }
      }
    } while (condition)
    //---------------------------------------------------------------------------
  }
  shuffle(newList)
  state.autoHelp.list = newList
  state.autoHelp.index = 0
  state.gridSearchType.forSearchIndex++
  if (lang == 'ja') {
    if (state.gridSearchType.forSearchIndex === state.gridSearchType.wordCategoryPoolsJa.length) {
      state.gridSearchType.forSearchIndex = 0
    }
  } else {
    if (state.gridSearchType.forSearchIndex === state.gridSearchType.forSearchLengthArray.length - 2) {
      state.gridSearchType.forSearchIndex = 0
    }
  }
  return {
    gameMatrix: newMatrix,
    leftToFind: 3,
    lettersToFind: forFindWords,
    gridSearchType: state.gridSearchType
  }
}

function mapStateToProps(state) {
  return {
    ...state[WORD_PAIRS_NAME]
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  ...wordSearchContainerActions,
  dispatch
}, dispatch)

class WordSearch extends React.Component {
  constructor(props) {
    // shuffle words for find 
    let wordsForSearch = []
    let wordCategoryPoolsJa = [
      ["kat_6", "hir_5"],
      ["kat_5", "hir_5"],
      ["kat_4", "hir_4"],
      ["kat_3", "hir_3"],
      ["kan_4"],
      ["kan_3"],
      ["kan_2"],
      ["kan_1"],
    ]
    if(lang == 'ja') {
      wordCategoryPoolsJa.map((round=>{
        round.map((item=>{
          wordsForSearch[item] = {
            array: shuffle(wordsJa[item]),
            index: 0
          }
        }))
      }))
    } else {
      wordsForSearch['4'] = {
        array: shuffle(WORDS_4[lang] ? WORDS_4[lang] : WORDS_4["en"]),
        index: 0
      }
      wordsForSearch['5'] = {
        array: shuffle(WORDS_5[lang] ? WORDS_5[lang] : WORDS_5["en"]),
        index: 0
      }
      wordsForSearch['6'] = {
        array: shuffle(WORDS_6[lang] ? WORDS_6[lang] : WORDS_6["en"]),
        index: 0
      }
      wordsForSearch['7'] = {
        array: shuffle(WORDS_7[lang] ? WORDS_7[lang] : WORDS_7["en"]),
        index: 0
      }
    }    
    props.setType({
      forSearchLengthArray: [7, 7, 6, 7, 6, 5, 6, 5, 5, 5, 4, 4, 4, 4, 4],
      wordCategoryPoolsJa: wordCategoryPoolsJa,
      wordsForSearch: wordsForSearch,
      forSearchIndex: 0,
      cellClick: cellClick,
      generateMatrix: generateMatrix
    }, 
    6, //points per click
    {
      remainingForAutoHelp: 1,
      list: [],
      index: 0
    })  // autohelp options
    super(props);
    this.state = {
      startOverlayTransitionIsFinished: false,
      progressInfoTransitionIsFinished: false
    }
  }

  componentWillUnmount() {

  }

  render() {
    if (this.props.exersizeState === 'gameOver') {
      this.timer = setTimeout(() => {
        this.props.dispatch({ type: "SHOW_GAME_OVER_SCREAN" });
      }, 1200);
    }
    return (
      <div className='App exercise-container'>
        <CSSTransition
          in={this.props.exersizeState === 'startScrean'}
          classNames="swipe"
          timeout={200}
          mountOnEnter
          unmountOnExit
          onExited={() => this.setState({ startOverlayTransitionIsFinished: true })}
        >
          <StartOverlay
            img={WordSearchImg}
            name={strings.WordSearch_name}
            title={strings.WordSearch_title}
            description={strings.WordSearch_description}
            btnText={strings.OverlayView_btn_start}
            btnId={analyticsActions.WordSearch.btnStart}
            onClick={() => { this.props.startPreExersize() }}
          />
        </CSSTransition>
        <CSSTransition
          in={this.props.exersizeState === 'scoreScrean' && this.state.progressInfoTransitionIsFinished}
          classNames="swipe"
          timeout={200}
          mountOnEnter
          unmountOnExit
        >
          <GameOver
            title={strings.WordSearch_name}
            points={this.props.points}
            countDown={this.props.countDown}
            exersizeState={this.props.exersizeState}
            lettersMatrix={this.props.lettersMatrix}
            analyticsActions={analyticsActions.WordSearch}
          />
        </CSSTransition>
        <CSSTransition
          in={
            (
              this.props.exersizeState === 'preexersize' ||
              this.props.exersizeState === 'gameStarted' ||
              this.props.exersizeState === 'gameOver'
            ) && this.state.startOverlayTransitionIsFinished
          }
          classNames="swipe"
          timeout={200}
          mountOnEnter
          unmountOnExit
          onExited={() => this.setState({ progressInfoTransitionIsFinished: true })}
        >

          <ProgressInfo
            timeLeft={this.props.timeLeft}
            points={this.props.points}
            name={strings.WordSearch_name}
            title={strings.WordSearch_title}
            game={
              <>
                <Timer
                  started={this.props.exersizeState === 'preexersize'}
                  increment={this.props.incrementCountDown}
                  interval={1000}
                  incrementCounter={this.props.countDown}
                  timerFinished={this.props.startGame}
                />
                <Timer
                  started={this.props.exersizeState === 'gameStarted'}
                  increment={this.props.increment}
                  interval={1000}
                  incrementCounter={this.props.timeLeft}
                  timerFinished={this.props.gameOverAction}
                />
                <CountDown key="countDown" countDown={this.props.countDown} />
                <Grid
                  exName="letter-search"
                  key="grid"
                  exersizeState={this.props.exersizeState}
                  onCellClick={this.props.cellClickAction}
                />
              </>
            }
          >
            <div className="col-md-12">
              {strings.WordsInput_name} <br></br>
              <span className="value">
                {this.props.exersizeState === 'gameStarted'
                  ? this.props.lettersToFind.join(", ")
                  : strings.SLMB_remaining}
              </span>
            </div>
          </ProgressInfo>
        </CSSTransition>
      </div>
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(WordSearch)
